import {
    getClassDailyStudyChapter, getClassLevelChapter,
} from "../../../network/Endpoint";
import {useEffect, useRef, useState} from "react";
import {useParams} from "react-router-dom";
import CurriculumDropdownInApp from "../components/classLesson/CurriculumDropdownInApp";
import {useRecoilState, useRecoilValue} from "recoil";
import {curriculumState} from "../../../recoil/curriculums/curriculumState";
import {mainClassState} from "../../../recoil/classes/classesState";
import StageBadgeDaily from "../components/classLesson/StageBadgeDaily";
import SideMenu from "../../../components/SideMenu";

const ClassDailyPage = () => {
    const [level, setLevel] = useState(null);
    const [supremeChapter, setSupremeChapter] = useState(null);
    const [chapter, setChapter] = useState(null);
    const [stage, setStage] = useState(null);
    const [stageResults, setStageResults] = useState([]);
    const param = useParams();
    const mainClass = useRecoilValue(mainClassState);
    const [classId, setClassId] = useState(param.classno);

    const [curriculumData, setCurriculumData] = useRecoilState(curriculumState);
    const [inAppCurriculumData, setInAppCurriculumData] = useState(null);
    const [selectedChapter, setSelectedChapter] = useState( null);

    const [subMenu, setSubMenu] = useState("chapter");


    /**
     * 학급의 커리큘럼 페이지 레벨 단원 정보 가져오기
     */
    const getClassData = async () => {
        if(!selectedChapter){
            try{
                const body = { type: "daily", classId: mainClass.classId };
                const res = await getClassLevelChapter(body);
                const statusCode = res.data.status.code;
                if (statusCode === "Success") {
                    setLevel(inAppCurriculumData[res.data.data.level-1]);
                    setSupremeChapter(inAppCurriculumData[res.data.data.level-1].supremeChapterList[res.data.data.supremeChapterSeq]);
                    setChapter(inAppCurriculumData[res.data.data.level-1].supremeChapterList[res.data.data.supremeChapterSeq].chapterList[res.data.data.chapterSeq]);
                    setSelectedChapter(null);
                    fetchGetChapterResult(inAppCurriculumData[res.data.data.level-1].supremeChapterList[res.data.data.supremeChapterSeq].chapterList[res.data.data.chapterSeq]);
                }
            }catch (error) {
                alert(`[${error.message}]\n 단원정보 로드 중 오류가 발생했어요.`);
            }
        }
    }

    const fetchGetChapterResult = async (_chapter) => {
        try {
            const body = { classId:  mainClass.classId, chapterId: _chapter.chapterId };
            const res = await getClassDailyStudyChapter(body);
            const statusCode = res.data.status.code;

            if (statusCode === "Success") {
                const data = res.data.data;
                setStageResults(data.classDailyStageResults);
            } else {
                alert(`ERROR: 학생 정보 로드 중 오류가 발생했어요. 아크수학으로 문의해 주세요.\n${res.data.status.message}`);
            }
        } catch (error) {
            alert(`[${error.message}]\n 학생 정보 로드 중 오류가 발생했어요.\n아크수학으로 문의해 주세요.`);
        }
    };
    //
    // /** ✅ mainClass가 변경될 때 최초 1회 실행 */
    // useEffect(() => {
    //     if (mainClass && mainClass.classId) {
    //         getClassData();
    //     }
    // }, [mainClass]); // ✅ mainClass가 변경될 때 실행됨

    useEffect(() => {
        if(curriculumData){
            setInAppCurriculumData(curriculumData.curriculumLevelList);
        }
    }, [curriculumData]);

    useEffect(()=>{
        if(inAppCurriculumData && mainClass && mainClass.classId){
            getClassData();
        }
    },[inAppCurriculumData, mainClass])

    useEffect(() => {
        if(chapter){
            fetchGetChapterResult(chapter);
        }
    },[chapter])

    return (
        <div className="flex flex-col items-center w-full max-md:max-w-full bg-[#F8F8F8] min-h-screen">
            <div>
                {/* 드롭다운 메뉴 */}
                <div className="flex flex-row justify-center items-center max-w-[1044px] w-full mt-12 mb-10 gap-3">
                    <div className="relative w-[1027px] h-[44px] ">
                        <CurriculumDropdownInApp
                            classId={mainClass.classId}
                            level={level}
                            setLevel={setLevel}
                            curriculumData={inAppCurriculumData}
                            supremeChapter={supremeChapter}
                            setSupremeChapter={setSupremeChapter}
                            chapter={chapter}
                            setChapter={setChapter}
                            selectedChapter={selectedChapter}
                            setSelectedChapter={setSelectedChapter}
                            menuType="daily"
                        />
                    </div>
                </div>
                <div className="flex max-w-[1044px] w-full mt-3 mb-40">
                    <div className="flex flex-row justify-between flex-wrap w-full">
                        {stageResults && stageResults.length > 0 ?
                            stageResults.map((result, index) => (
                                <StageBadgeDaily
                                    key={index}
                                    index={index}
                                    stageSummary={result}
                                    stage={result}
                                    setStage={setStage}
                                    setSubMenu={setSubMenu}
                                    classInfo={mainClass}
                                    level={level}
                                />
                            ))
                            : (
                                <div
                                    className="flex flex-row items-center w-full rounded-[20px] bg-white border-[1px] border-[#DADADA] h-[78px] p-5 gap-3 mt-3">
                                    <div
                                        className="flex justify-center items-center text-black text-[18px] font-[500] h-[34px] p-2 w-full">
                                        학습한 내역이 없습니다.
                                    </div>
                                </div>
                            )
                        }
                    </div>
                </div>
            </div>
            <SideMenu></SideMenu>
        </div>
    );
};

export default ClassDailyPage;
